export default __webpack_public_path__ + "media/images/fx_factures_yellow-a84a768ff5ffc0ab68bb985b70059d86.png";